<template>
  <div>
    <area-chart
      :info-card="computedInfoCards"
      :data-series="computedSeries"
      :time-stamps="timeStamps"
      :format-percentage="true"
    />
  </div>
</template>

<script>
import AreaChart from '../widgets/BarChart.vue'

export default {
  components: { AreaChart },
  computed: {
    objectsCountStats() {
      return this.$store.state.storageAnalytics.objectsCountStats.stats ?? []
    },
    loadingObjectsCountStats() {
      return this.$store.state.storageAnalytics.loadingObjectsCountStats
    },
    peakComputed() {
      const data = this.computedSeries.map(x => x.data)[0]
      const peak = data.length !== 0 ? Math.max(...data) : 0
      const peakIndex = data.indexOf(peak)

      return {
        peak: peak.toLocaleString(),
        peakTime: (this.computedSeries.map(x => x.timestamps)[0])[peakIndex],
      }
    },
    objectsCount() {
      const data = this.computedSeries.map(x => x.data)[0]
      const dataValue = data[data.length - 1]

      return dataValue ? dataValue.toLocaleString() : '-'
    },
    computedInfoCards() {
      const infoCard = [
        {
          id: 1,
          title: 'Peak',
          description: `${this.peakComputed.peak} Objects`,
          loading: this.loadingObjectsCountStats,
        },
        {
          id: 2,
          title: 'Peak Time',
          description: `${this.unixTimestampToDateTime(this.peakComputed.peakTime)}`,
          loading: this.loadingObjectsCountStats,
        },
        {
          id: 3,
          title: 'Total Objects',
          description: `${this.objectsCount} Objects`,
          loading: this.loadingObjectsCountStats,
        },
      ]
      return infoCard
    },
    computedSeries() {
      return this.getFormattedSeries(this.objectsCountStats)
    },
    timeStamps() {
      if (this.objectsCountStats && this.objectsCountStats.length > 0) {
        return this.objectsCountStats.map(x => x.timestamp)
      }

      return null
    },
  },
  methods: {
    getFormattedSeries(dataList) {
      const series = [{
        name: 'Objects',
        data: dataList?.map(item => item.value) || [],
        timestamps: dataList?.map(item => item.timestamp) || [],
      }]

      return series
    },
  },
}
</script>
